var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-2"},[_c('b-form-select',{class:_vm.selectClass,attrs:{"options":_vm.endOfExerciseOptions,"size":"sm"},on:{"change":_vm.setFilter},model:{value:(_vm.option),callback:function ($$v) {_vm.option=$$v},expression:"option"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }